import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`As a package owner or maintainer, you can transfer ownership of a package you no longer wish to maintain to another trusted npm user using either the npm website or the command line.`}</p>
    <p>{`For more information on how npm support handles package name disputes between users, you can refer to npm's `}<a parentName="p" {...{
        "href": "/policies/disputes"
      }}>{`package name dispute policy`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You cannot transfer a scoped package to another user account or organization, because a package's scope `}<em parentName="p">{`is`}</em>{` the user account or organization name.  You will need to create a new package in the new scope.`}</p>
    </Note>
    <h2>{`Transferring a package from a user account to another user account on the website`}</h2>
    <p>{`To transfer a package you own or maintain to another user, follow these steps:  `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the package page for the package you want to transfer, replacing `}<inlineCode parentName="p">{`<your-package-name>`}</inlineCode>{` with the name of your package:
`}<inlineCode parentName="p">{`https://www.npmjs.com/package/<your-package-name>`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the package Admin tab, under "Maintainers", enter the npm username of the new maintainer.`}</p>
        <Screenshot src="/packages-and-modules/updating-and-managing-your-published-packages/package-maintainer-invite.png" alt="Screenshot showing text field to invite maintainers" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click "Invite."`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To remove yourself as a maintainer, under the maintainers list, click the "x" next to your username.`}</p>
        <Screenshot src="/packages-and-modules/updating-and-managing-your-published-packages/package-maintainer-list.png" alt="Screenshot showing maintainer list" mdxType="Screenshot" />
      </li>
    </ol>
    <h2>{`Transferring a package from a user account to another user account on the command line`}</h2>
    <p>{`To transfer a package to another npm user using the CLI, run the `}<a parentName="p" {...{
        "href": "cli/owner"
      }}><inlineCode parentName="a">{`npm owner add`}</inlineCode></a>{` command replacing `}<inlineCode parentName="p">{`<their-username>`}</inlineCode>{` with the other user's npm username. An email invitation is sent to the other user. After the user has accepted the invitation, run the `}<inlineCode parentName="p">{`npm owner rm`}</inlineCode>{` command replacing `}<inlineCode parentName="p">{`<your-username>`}</inlineCode>{` with your npm username:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm owner add <their-username> <package-name>

# new maintainer accepts invitation

npm owner rm <your-username> <package-name>
`}</code></pre>
    <p>{`If you have two-factor authentication enabled for writes, add a one-time password to the command, `}<inlineCode parentName="p">{`--otp=123456`}</inlineCode>{` (where `}<em parentName="p">{`123456`}</em>{` is the code from your authenticator application).`}</p>
    <pre><code parentName="pre" {...{}}>{`npm owner add <their-username> <package-name> --otp=123456

# new maintainer accepts invitation

npm owner rm <your-username> <package-name> --otp=123456
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      